import { Component, EventEmitter, input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ViewConfigSave } from 'src/app/CommonFiles/UIModels';

@Component({
  standalone: false,
  selector: 'app-view-save',
  templateUrl: './view-save.component.html'
})
export class ViewSaveComponent implements OnInit {
  model = input<ViewConfigSave>();
  isNew = input<boolean>();

  @Output() cancel = new EventEmitter<void>();
  @Output() save = new EventEmitter<ViewConfigSave>();

  editForm: FormGroup;

  constructor() { }

  ngOnInit(): void { 
    this.editForm = new FormGroup({
      viewConfigTitle: new FormControl(this.model().viewConfigTitle),
      keepFilters: new FormControl(this.model().keepFilters)
    });
  }

  onCancel() {
    this.cancel.emit();
  }

  onSave() {
    const payload = this.editForm.getRawValue();
    this.save.emit(payload);
  }
}
